module.exports = __webpack_public_path__ + "img/logo-fidelidade.ffaa3838.png";